// extracted by mini-css-extract-plugin
export default {"container":"emptyMessage_container__35Qky"};